import {Container} from 'src/components/container/Container'
import {Flexbox} from 'src/components/flexbox/Flexbox'
import {AdminHostApprovalRejectedImages} from '../admin-host-approval-rejected-images/AdminHostApprovalRejectedImages'
import {AdminHostApprovalCompletedApprovedImages} from '../admin-host-approval-completed-approved-images/AdminHostApprovalCompletedApprovedImages'

export const AdminHostApprovalCompletedTaskSection = ({taskId}: {taskId: number}) => {
    return (
        <Container fullHeight={false}>
            <Flexbox direction="column" gap={4}>
                <AdminHostApprovalRejectedImages taskId={taskId} />
                <AdminHostApprovalCompletedApprovedImages taskId={taskId} />
            </Flexbox>
        </Container>
    )
}
